import { LotteryType } from '../Api/CRM/Responses/LotteryResponse';
import { LotteryTypes } from '../components/play/Types/Enums';

export function isRaffleType(lotteryType: LotteryType): boolean {
    return [LotteryTypes.RaffleOpen, LotteryTypes.RaffleClosed].includes(lotteryType as LotteryTypes);
}

export function isPickType(lotteryType: LotteryType): boolean {
    return lotteryType === LotteryTypes.Pick;
}

export function isKenoType(lotteryType: LotteryType): boolean {
    return lotteryType === LotteryTypes.Keno;
}

export function isLotteryType(lotteryType: LotteryType): boolean {
    return lotteryType === LotteryTypes.Lottery;
}

export function isSoccerType(lotteryType: LotteryType): boolean {
    return lotteryType === LotteryTypes.Soccer;
}
